/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'KI-Prüfung',
    AIReviewFailed: 'KI-Prüfung fehlgeschlagen',
    AIReviewPassed: 'KI-Prüfung bestanden',
    AIReviewStatus: 'Status KI-Prüfung',
    AIReviewing: 'KI-Prüfung wird geprüft',
    America: {},
    CheckSupportInstall: 'Prüfen, ob Nachrüstung unterstützt wird',
    ImporterCommunityDisplayName: 'Anzeigename der Importeursgemeinschaft',
    ImporterContactEmail: 'Kontakt-E-Mail des Importeurs',
    IndicatorLight: 'Kontrollleuchte',
    Instruction: 'Notiz',
    MostPicture4OrVideo: '(Maximal 4 Bilder / 1 Video)',
    PleaseContactPersonnelCommunicating: 'Bitte kontaktieren Sie das CFMOTO-Personal für die Kommunikation',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Über das Konto',
    aboutVehicle: 'Über das Fahrzeug',
    accountApplyRejected: 'Antrag auf Kontolöschung abgelehnt',
    accountCancel: 'Antrag auf Kontolöschung',
    accountDeletExplain: 'Anleitung zur Kontolöschung',
    accountDelete: 'Kontolöschung',
    accountDeleted: 'Konto gelöscht',
    accountFormatError: 'Falsches Kontoformat/Benutzer existiert nicht.  Bitte stimmen Sie die entsprechenden Texte auf den tatsächlichen Anlass ab',
    action: 'Betrieb',
    actionFail: 'Operation fehlgeschlagen',
    actionSuccess: 'Operation erfolgreich',
    activeScore: 'Aktives Scoring',
    activeTrigger: 'Benutzer lösen aktiv aus (Über APP – Zur Bewertung)',
    activity: 'Aktivität',
    activityCancel: 'Absage der Veranstaltung',
    activityCover: 'Aktivitätsabdeckung',
    activityDetails: 'Aktivitätsdetails',
    activityId: 'Aktivitäts-ID',
    activityList: 'Liste der Aktivitäten',
    activityManagement: 'Management der Aktivität',
    activitySearch: 'Aktivitätssuche',
    activityTime: 'Aktivitätszeit',
    activityTitle: 'Titel der Aktivität',
    activityVenue: 'Ort der Aktivität',
    adaptable: 'Fittings für',
    add: 'hinzufügen',
    addAccountDeletExplain: 'Kontolöschungshinweis hinzufügen',
    addAuthenticationTime: 'Authentifizierungszeit hinzufügen',
    addDataDeletExplain: 'Hinweis zur Datenlöschung hinzufügen',
    addEmail: 'Neue e-mail',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addInformationCategory: 'Neue Informationskategorie hinzufügen',
    addInformationContent: 'Fügen Sie neue Informationsinhalte hinzu',
    addKolUserAuthentication: 'KOL-Benutzerauthentifizierung hinzufügen',
    addPicture: 'Bild hinzufügen',
    addPrivacyAgreement: 'Datenschutzvereinbarung hinzufügen',
    addPrivacySubmitSure: 'Das Datum des Inkrafttretens und die Änderungsbeschreibung der neuen Datenschutzrichtlinie können nach der Übermittlung nicht mehr angepasst werden. Bestätigen Sie die Übermittlung.',
    addPushConfiguration: 'Push-Konfiguration hinzufügen',
    addQuestion: {},
    addSdkStaement: 'SDK-Anweisung hinzufügen',
    addServiceIntroduce: 'Einführung in neue Dienstleistungen',
    addShowroomModel: 'Showroom-Modelle hinzufügen',
    addThisUser: 'Diesen Benutzer hinzufügen',
    addTopic: 'Ein Thema hinzufügen',
    addUser: 'Benutzer hinzufügen',
    addUserAgreement: 'Benutzervereinbarung hinzufügen',
    addUserRole: 'Nutzerrolle hinzufügen',
    addVehicleModel: 'Neue Modelle',
    addVehicleModelCategory: 'Neue Fahrzeugkategorie',
    addVideo: 'Video hinzufügen',
    addedBy: 'Hinzugefügt von',
    additionalFeedback: 'Zusätzliches Feedback',
    administratorUnbind: 'Administrator trennen',
    afternoon: 'Nachmittag',
    agreeSignOut: 'Zustimmung zur Beendigung',
    agreementContent: 'Vereinbarung',
    all: 'Alle',
    allArea: 'Zielland/-region',
    allComment: 'Alle Kommentare',
    allImportSuccess: 'Import abgeschlossen.  Alle erfolgreich importiert',
    allUser: 'Alle Benutzer',
    allVehicleModel: 'Alle Modelle',
    alreadyOver: 'Alles hier drin',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA bedeutet, dass das Fahrzeug die neueste Firmware-Software aus der Cloud über das Mobilfunknetz herunterlädt und Sie das Fahrzeug online über CFMOTO RIDE aktualisieren können, um das Fahrerlebnis kontinuierlich zu optimieren',
    answerOta2:
      'Wenn eine neue Version des TFT-Displays aktualisiert werden kann, erhalten Sie eine Upgrade-Benachrichtigung. Wenn unten auf der aktuellen Seite %s angezeigt wird, bedeutet dies, dass das TFT-Display des Fahrzeugs nicht aktualisiert werden muss.',
    answerOta3: 'Sie können oben rechts auf %s klicken, um vorab weitere OTA-Bedienanweisungen zu erhalten',
    anyCar: 'Gibt es ein Auto?',
    appRating: 'Verwaltung des Bewertungsmechanismus',
    appType: 'Telefonanlage',
    appVersion: 'App Version',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Antragszeit',
    applyUnbinding: 'Entbinden anwenden',
    appointmentReleaseTime: 'Terminfreigabezeit',
    approval: 'Freigabe',
    arrivalNumberDescription: 'Die tatsächliche Anzahl der Ankünfte am Geräteterminal nach dem Versand der Benachrichtigung (die Ankünfte nach 5 Tagen werden nicht gezählt)',
    arrivalNumberVolume: 'Anzahl der Ankünfte',
    askAllowUserSpeakInCommunity: 'Erlauben Sie dem verbotenen Benutzer, in der Gemeinschaft zu posten',
    askApproveIt: 'Es zu genehmigen',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Ob diese Informationskategorie gelöscht werden soll',
    askDeleteInformationContent: 'Ob Informationsinhalte gelöscht werden sollen',
    askDeleteKolUserAuthentication: 'Sind Sie sicher, diese KOL-Benutzerauthentifizierung zu löschen?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Diese Aktivität löschen',
    askDeleteThisBanner: 'Dieses Banner löschen',
    askDeleteThisComment: 'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten',
    askDeleteThisPost: 'Diesen Beitrag löschen',
    askDeleteThisTopic: 'Dieses Thema löschen',
    askDeleteVehicleType: 'Sind Sie sicher, das Fahrzeugmodell zu löschen',
    askDeleteVehicleTypeCategory: 'Ob diese Modellkategorie gelöscht werden soll',
    askDeleteVehicleTypeDetails: 'Ob die Automodelldetails gelöscht werden sollen',
    askDeleteVehicleTypeSeries: 'Ob diese Modellreihe gelöscht werden soll',
    askLogout: 'Sind Sie sicher, dass Sie das System verlassen wollen?',
    askNotApproveIt: 'Es nicht zu genehmigen',
    askSaveSettings: 'Die Einstellungen wurden noch nicht gespeichert, möchten Sie sie speichern?',
    associatedPostNumber: 'Anzahl der zugehörigen Beiträge',
    associatedPosts: 'Zugehörige Beiträge',
    associatedVehicle: 'dazugehöriges Fahrzeug',
    assoclatedContent: 'Assoziierte Inhalte',
    atmosphereCContent: 'Die Einstellungen wurden noch nicht gespeichert, möchten Sie sie speichern?',
    atmosphereContent1Msg1: 'Nach dem Einschalten der Funktion schaltet das Mobiltelefon Bluetooth ein und die APP läuft weiter. Bei Annäherung an das Fahrzeug von nah nach fern kann das Fahrzeug automatisch entriegelt und eingeschaltet werden.',
    atmosphereContent1Msg2: 'Wenn es normalerweise nicht entriegelt und eingeschaltet ist, drücken Sie zum Entriegeln und Einschalten den Netzschalter des Fahrzeugs',
    atmosphereContent1Msg3: 'Die automatische Proximity-Entsperrung wird nur einmal ausgelöst, bevor die Bluetooth-Verbindung getrennt wird.',
    atmosphereContent2Msg1:
      'Nach dem Einschalten der Funktion schaltet sich das Fahrzeug nach 5 Sekunden automatisch aus, nachdem die drei Bedingungen des Abschaltens des Fahrzeugs erfüllt sind, die Fahrzeuggeschwindigkeit 0 beträgt und der Bügel heruntergelassen wurde',
    atmosphereContent2Msg2: 'Wenn das Fahrzeug während der automatischen Abschaltzeit gestartet wird, die Fahrzeuggeschwindigkeit nicht 0 ist oder der Bügel weggelegt wird, wird die automatische Abschaltung abgebrochen',
    atmosphereContent3Msg1:
      'Nach dem Einschalten der Funktion schaltet das Mobiltelefon beim Ausschalten des Fahrzeugs Bluetooth ein und die APP läuft weiter oder trägt den physischen Schlüssel.Wenn Sie sich dem Fahrzeug von weit nach nah nähern, blinken die Fahrzeuglichter, um Gäste willkommen zu heißen',
    atmosphereContent3Msg2: 'Um zu verhindern, dass häufiges Auslösen zu einem Stromausfall des Fahrzeugs führt, wird die Willkommensfunktion, nachdem sie innerhalb von 30 Sekunden zweimal ausgelöst wurde, erst 30 Minuten später wieder aufgenommen',
    atmosphereContent4Msg1: 'Nachdem die Funktion eingeschaltet wurde, werden die Fern- und Abblendlichter automatisch für 10 Sekunden eingeschaltet, nachdem das Fahrzeug ausgeschaltet wurde',
    atmosphereIntroduce1: 'In der Nähe von Anweisungen zum automatischen Entsperren',
    atmosphereIntroduce2: 'Anweisungen zum automatischen Ausschalten',
    atmosphereIntroduce3: 'Anweisungen zum automatischen Aufwachen',
    atmosphereIntroduce4: 'Verzögertes Ausschalten der Lichter',
    atmosphereSetINfo: 'Die neuen Einstellungen werden innerhalb von 1-3 Minuten nach dem Einschalten des Fahrzeugs wirksam, bitte stellen Sie sicher, dass sich das Fahrzeug in einer guten Signalposition befindet',
    auditStatus: 'Freigabestand',
    authenticatedName: 'Authentifizierter Name',
    avatar: 'Profilbild',
    backApply: 'Antrag zurückziehen',
    backApplySuccess: 'Antragsrücknahme erfolgreich',
    backHome: 'Zurück zur Startseite',
    bannerDisplayImages: 'Bannerbild',
    bannerList: 'Banner-Liste',
    bannerManagement: 'Banner-Management',
    bannerPictrure: 'Banner-Zeichnung',
    bannerSearch: 'Banner-Suche',
    bannerTitle: 'Banner-Titel',
    batchImport: 'Batch-Import',
    batchUser: 'Batch-Benutzer',
    beijingTime: 'UTC+8-Zeit',
    belogCategory: 'Kategorie',
    belongCategory: {},
    bindDevice: 'Gerät binden',
    bindVehicle: 'Fahrzeug binden',
    bindingStatus: 'Verbindungs-Status',
    bindingText1: '1.\tTelematikdienste _',
    bindingText10: '1.1.2.\tBereitstellen von Routenplanung während der Navigation, einschließlich Berechnung der Entfernung zwischen Fahrzeugen und Fußgängernavigation zum Auffinden eines Fahrzeugs .',
    bindingText11: '1.2.\tSenden der erforderlichen Benachrichtigungen an den Kunden basierend auf den Bedingungen des Fahrzeugs.',
    bindingText12:
      '1.2.1.\tCFMOTO sendet dem Kunden Benachrichtigungen zur Fahrzeugwartung (z. B. basierend auf der Gesamtstrecke, die der Kunde zurückgelegt hat, dem Zeitpunkt, zu dem der Kunde das Fahrzeug gekauft hat, der Zeit oder der erforderlichen Fahrstrecke für die Fahrzeugwartung) .',
    bindingText13: '1.2.2.\tBasierend auf Fahrzeugdaten sendet CFMOTO dem Kunden Benachrichtigungen über ungewöhnliche Situationen; inkl. Datenanalyse durch OEM (je nach Modell) zur Kundenbetreuung und Folgeoptimierung des Fahrzeugs .',
    bindingText14: '1.3.\tUnterstützung bei der Analyse der Unfallursache, wenn der Kunde einen schweren Unfall des Fahrzeugs meldet.',
    bindingText15:
      '1.3.1.\tIm Falle eines schweren Unfalls des Fahrzeugs, etwa wenn sich das Fahrzeug während der Fahrt überschlägt oder auf die Seite kippt, unterstützt CFMOTO den Kunden auf Wunsch bei der Klärung, ob der Unfall auf einen Mangel des Fahrzeugs oder andere Umstände zurückzuführen ist. Die Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
    bindingText16: '1.3.2.\tSoweit die verfügbaren Daten dies zulassen, wird CFMOTO die Daten im Hinblick auf die Unfallursache auswerten und dem Kunden einen entsprechenden Bericht zukommen lassen.',
    bindingText17: '1.4.\tUnterstützung des Kunden bei der Wiedererlangung des Fahrzeugs nach Fahrzeugverlust .',
    bindingText18:
      '1.4.1.\tBei Verlust des Fahrzeugs stellt CFMOTO dem Kunden auf Anfrage und sofern verfügbar Standortdaten des Fahrzeugs und andere nützliche Statusdaten des Fahrzeugs (z. B. Ort der letzten Aktivierung, aktueller Fahrzeugstatus usw.) zur Verfügung.',
    bindingText19: '1.4.2.\tDie Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
    bindingText2:
      'CFMOTO Powersports, Inc. (im Folgenden als „ CFMOTO “ bezeichnet ) stellt Fahrzeugtelematikdienste für den Kunden bereit, der das CFMOTO-Fahrzeug gekauft hat (im Folgenden als „Kunde“ bezeichnet ). Für diese Dienste verwendet CFMOTO vom Fahrzeug aufgezeichnete Daten über das Fahrzeug und sein Fahrverhalten im relevanten Zeitraum. Im Einzelnen handelt es sich um folgende Daten:',
    bindingText20: '1.5.\tMeldung von After-Sales-Problemen .',
    bindingText21:
      '1.5.1.\tCFMOTO sammelt aus der Ferne Fehlercode-Benachrichtigungen, die vom Fahrzeug im Falle einer Fehlfunktion seiner Komponenten gesendet werden, und stellt entsprechende Informationen auf Anfrage des Kunden direkt dem Kunden zur Verfügung.',
    bindingText22: '1.5.2.\tDie Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
    bindingText23: '2.\tEinschränkungen und Ausschlüsse des Dienstes',
    bindingText24:
      '2.1.\tEs wird ausdrücklich darauf hingewiesen, dass bauliche oder sonstige technische Änderungen am Fahrzeug die Bereitstellung der Dienste einschränken oder sogar unmöglich machen können, da die Dienste von der korrekten Bereitstellung der Fahrzeugdaten abhängig sind.',
    bindingText25: '2.2.\tWenn solche Dienste aufgrund der Leistung von Daten- oder Telekommunikationsnetzen Dritter nicht erbracht werden können, ist jegliche Haftung von CFMOTO ausgeschlossen .',
    bindingText26: '3.\tPrivatsphäre',
    bindingText27:
      'dem CFMOTO- Fahrzeug die geltenden Datenschutzbestimmungen einhalten . Die Bedingungen der Datenschutzrichtlinie von C FMOTO sind in dieser CFMOTO RIDE APP dargelegt . Als Ergänzung zur Datenschutzerklärung entspricht dieser Hinweis der Datenschutzerklärung . Und der Kunde kann sich auf die Datenschutzerklärung für einige datenverarbeitungsbezogene Inhalte beziehen, die nicht von dieser Erklärung abgedeckt sind.',
    bindingText28: '4.\tKundendienst',
    bindingText29:
      '4.1.\tDer Kunde kann gerne datenschutzbezogene Fragen, Kommentare oder Bedenken an CFMOTORIDEAPP@cfmotousa.com senden oder an folgende Adresse schreiben: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Der Kunde kann auch anrufen CFMOTO-Kundendienst unter (888) 823-6686. ',
    bindingText3: 'Fahrverhaltensdaten des Benutzers : einschließlich Beschleunigung, Verzögerung, Geschwindigkeit, Kurvenfahrt, letzte Fahrzeit und letzte Fahrkilometer .',
    bindingText30: '5.\tRevisionen _',
    bindingText31: '5.1.\tCFMOTO behält sich das Recht vor, diese Mitteilung jederzeit zu ändern, aber wir werden Überarbeitungen auf CFMOTO RIDE veröffentlichen App und/oder Benachrichtigung, bevor wir dies tun, sofern angemessen.',
    bindingText4:
      'Fahrzeugstatusdaten: Bezieht sich auf den Echtzeitstatus des Fahrzeugs, einschließlich Fahrmodus, Restkraftstoff, sofortiger Kraftstoffverbrauch, Kilometerstand, Echtzeit-Gang des Fahrzeugs, Motordrehzahl, Reifendruck, Reifentemperatur, Batterieaktivierungsspannungsdaten , Kühlmitteltemperatur, Status der elektronischen Sperre, Softwareversion des intelligenten Geräts, Signalstärke von Smart Devices, aktuelle Einstellung des Dashboards.',
    bindingText5:
      'Fahrzeugalarmdaten: Alarmdaten, die gesendet werden, wenn bestimmte Daten einen voreingestellten Wert überschreiten, wie z. B. Motortemperatur, überhöhte Geschwindigkeit, überhöhte Fahrzeit, hohe Kühlmitteltemperatur, anormale Fahrzeugbewegung, anormaler Reifendruck, Vibration, Kippen, Zusammenstoß usw .',
    bindingText6: 'Fahrzeugfehlerinformationen: bezieht sich auf die Fehlercodes, die von jedem internen Teil des Fahrzeugs gemeldet werden.',
    bindingText7: 'Fahrzeugstandortdaten: bezieht sich auf den spezifischen geografischen Aufenthaltsort des Fahrzeugs.',
    bindingText8: '1.1.\tBereitstellen _ den Kunden mit fahrzeugbezogenen Diensten über die CFMOTO RIDE APP .',
    bindingText9: '1.1.1.\tAPP fernverwalten (einschließlich Anzeigen des Fahrzeugstandorts, Einstellen der Fahrzeuginformationen und -funktionen, Fernsteuerung des Fahrzeugstatus usw.).',
    bindingUser: 'Benutzer binden',
    bound: 'Verbunden',
    businessType: 'Geschäftstyp',
    button: 'Knopf',
    callbackedApply: 'Sie haben Ihren Antrag auf Kontolöschung am yyyy-MM-dd HH:mm:ss zurückgezogen',
    callbackedApplySyncTip:
      'Ihr Antrag auf Kontolöschung wurde am JJJJ-MM-TT HH:mm:ss eingereicht.  Wir werden Ihr Konto und die damit verbundenen Daten 15 Tage nach Erhalt des Antrags endgültig löschen.  Nach der Löschung können Sie den CFMOTO RIDESYNC-Dienst nicht mehr nutzen. Um Ihre Kontolöschung zu stornieren, besuchen Sie bitte erneut die Webseite oder loggen Sie sich innerhalb von 15 Tagen in die APP ein, um den Antrag auf Kontolöschung zurückzuziehen.',
    callbackedApplyTip:
      'Ihr Antrag auf Kontolöschung wurde am JJJJ-MM-TT HH:mm:ss eingereicht.  Wir werden Ihr Konto und die damit verbundenen Daten 15 Tage nach Erhalt des Antrags endgültig löschen.  Nach der Löschung können Sie den CFMOTO RIDE-Dienst nicht mehr nutzen. Um Ihre Kontolöschung zu stornieren, besuchen Sie bitte erneut die Webseite oder loggen Sie sich innerhalb von 15 Tagen in die APP ein, um den Antrag auf Kontolöschung zurückzuziehen.',
    cancel: 'Abbrechen',
    cancellationAgreement: 'Globale Einstellungen',
    cancelled: 'Storniert',
    carOwner: 'Besitzer',
    carUserScore: 'Bewertungen der Fahrzeugbesitzer',
    cardPass: 'Erfolgreiche Identitätsprüfung!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Wechsel zur Authentifizierung mit Verifizierungscode',
    changeDescriptionType: 'Beschreibung ändern',
    changeDescriptionTypeSelectNo: 'Beinhaltet keine Änderungen der Vorschriften zur Verarbeitung personenbezogener Daten',
    changeDescriptionTypeSelectYes: 'Änderungen der Vorschriften zur Verarbeitung personenbezogener Daten',
    changeEmailInfo: 'Wechseln Sie zu E-Mail',
    changeFail: 'Die Statusänderung ist fehlgeschlagen',
    changeOne: 'Ändern',
    changePassValidate: 'Wechsel zur Authentifizierung mit Passwort',
    changePasswordFailed: 'Passwort-Änderung fehlgeschlagen',
    changePasswordSuccessful: 'Passwort-Änderung erfolgreich',
    changePhoneInfo: 'Zur Telefonnummer wechseln',
    changeStore: 'Geschäft ändern',
    changeSuccess: 'Status erfolgreich geändert',
    channelType: 'Feedback-Kanal',
    characterLimitExceeded: 'Zeichenlimit überschritten',
    checkConfigurationTwo: 'Chinesisch oder Englisch %s ist nicht vollständig konfiguriert, überprüfen Sie bitte',
    checkCopyWriting: 'Der chinesische oder englische Inhalt ist nicht ausgefüllt, bitte überprüfen Sie dies',
    checkEmpty: '%s ist leer, bitte überprüfen',
    checkTriggerType: 'Es liegt eine Bedingung für den Auslösemechanismus vor, die nicht ausgefüllt wurde. Bitte überprüfen Sie dies',
    checkUpdate: 'Updates prüfen',
    cityFilter: 'Stadtfilter',
    clickImmediateFeedback: 'Klicken Sie hier, um jetzt Feedback zu geben',
    clickNumber: 'Die Anzahl der Klicks',
    clickNumberDescription: 'Die tatsächliche Anzahl der Klicks von Nutzern, nachdem die Benachrichtigung erfolgreich angezeigt wurde (die Klicks nach 5 Tagen werden nicht gezählt)',
    clickNumberVolume: 'Anzahl der Klicks',
    clickToFeedback: 'Zum Feedback klicken',
    clicks: 'Klicks',
    closeNum: 'Schließung',
    closeTask: 'Aufgabe abgebrochen',
    code: 'Bestätigungs-Code',
    colorPicture: 'Farbblockbild',
    comment: 'Kommentar',
    commentContent: 'Kommentare',
    commentList: 'Kommentarliste',
    commentNumber: 'Anzahl der Kommentare',
    commentTime: 'Kommentarzeit',
    communication: 'in Kommunikation',
    community: 'Gemeinschaft',
    communityManagement: 'Management der Gemeinschaft',
    communityRule: 'Gemeinschaftsregel',
    completePuzzle: 'Bitte lösen Sie das Rätsel',
    completed: 'abgeschlossen',
    condition: 'Zustand',
    configureLanguage: 'Sprache konfigurieren',
    configurePicture: 'Bild konfigurieren',
    confirm: 'Bestätigen',
    confirmDeletePictures: 'Bestätigen Sie, um dieses Bild zu löschen',
    confirmReviewNoPass: 'Bestätigen Sie, dass die Überprüfung fehlgeschlagen ist',
    confirmReviewPass: 'Bestätigen Sie, die Überprüfung zu bestehen',
    consultDealer: 'Bitte wenden Sie sich an Ihren örtlichen Händler',
    contact: 'Ihr Antrag auf Kontolöschung wurde abgelehnt. Wenn Sie Fragen haben, wenden Sie sich bitte für eine Beratung an it@cfmoto.com.',
    contactMail: 'E-Mail Adresse',
    contactMethod: 'Kontakt',
    contactUs: 'Kontaktieren Sie uns',
    content: 'Inhalt',
    contentType: 'Art des Inhalts',
    copyFail: 'Das Kopieren ist fehlgeschlagen',
    copyLink: 'Link kopieren',
    copySuccess: 'Erfolgreich kopiert',
    copyWriting: 'Popup-Inhalte',
    country: 'Land/Region',
    countryCode: 'Landesvorwahl',
    countryName: 'Land',
    countryNumber: 'Landescode',
    countryRegion: 'Land / Region',
    create: 'Neuer Zusatz',
    createBy: 'Ersteller',
    createStore: 'Geschäft erstellen',
    createTime: 'Erstellungszeitpunkt',
    cs_CZ: 'Tschechisch',
    currency: {},
    currentConfig: {},
    currentCountryStoreTotal: 'Gesamtzahl der Geschäfte im aktuellen Land',
    currentTime: 'Aktuelle Uhrzeit',
    customPage: 'Benutzerdefinierte Seite',
    customSettings: 'Individuelle Spalten',
    dataDeletExplain: 'Anleitung zur Datenlöschung',
    dataDelete: 'Datenlöschung',
    dataDeleteApply: 'Antrag auf Datenlöschung',
    dataFormatError: 'Datenformatfehler',
    dataPermissionScope: 'Umfang der Datenberechtigung',
    dataType: 'Datentyp',
    dayOne: 'Tage einmal',
    days: 'Tag',
    daysAgo: 'Vor %s Tagen',
    de_DE: 'Deutsch',
    dealDate: 'Bearbeitungszeit',
    dealerOperationList: 'Liste der Händleroperationen',
    dealerOperationQuery: 'Händlerbetriebsabfrage',
    dealerOperationRecord: 'Händlerbetriebs-Protokoll',
    dealerStore: 'Händlergeschäfte',
    dealerStoreImportTempateName: 'Vorlage für den Import von Händlerfilialen',
    dealerStoreQuery: 'Abfrage von Händlergeschäften',
    dealers: 'Importeur',
    default: 'Standard',
    defaultMap: 'Standard Karte',
    delete: 'Löschen',
    deleteAccountSYNCStep: 'Sie können die folgenden Schritte ausführen, um die Löschung Ihres CFMOTO RIDESYNC-Kontos zu beantragen',
    deleteAccountStep: 'Sie können die folgenden Schritte ausführen, um die Löschung Ihres CFMOTO RIDE-Kontos zu beantragen',
    deleteDataSYNCStep: 'Sie können die folgenden Schritte ausführen, um die Löschung Ihrer CFMOTO RIDESYNC-Daten zu beantragen',
    deleteDataStep: 'Sie können die folgenden Schritte ausführen, um die Löschung Ihrer CFMOTO RIDE-Daten zu beantragen',
    deleteFail: 'Löschung fehlgeschlagen',
    deleteFinish: 'Löschung abgeschlossen',
    deleteKolUserAuthentication: 'KOL-Benutzerauthentifizierung löschen',
    deleteStore: 'Geschäft löschen',
    deleteSuccess: 'Löschung erfolgreich',
    deleteTip: 'Möchten Sie diesen Beitrag wirklich löschen? Einmal gelöschte Informationen können nicht wiederhergestellt werden',
    deleteVersionWarn: 'Ob dieser Versionseintrag gelöscht werden soll',
    deleteVideo: 'Dieses Video löschen?',
    detailAddress: 'Vollständige Adresse',
    details: 'Details',
    determine: 'Na klar',
    deviceCodeGet: 'Gerätecode abrufen:',
    deviceContent:
      'Der Gerätecode des elektronischen Zaunempfängers (als Schlüssel bezeichnet) ist eine Folge von 10-stelligen Codes. Der Gerätecode, der QR-Code und das CE-Zeichen sind auf dem silbernen PVC-Selbstklebeaufkleber aufgedruckt. Insgesamt gibt es drei Aufkleber, einer wurde an der Fahrzeugkarosserie angebracht (Sie müssen das Sitzkissen anheben, um ihn sehen zu können); Die anderen beiden werden in der Zubehörtasche des Fahrzeugs untergebracht. (Es wird empfohlen, dass Benutzer das Etikett im Fahrzeughandbuch oder auf der Fernbedienung anbringen.)\nBitte drücken und halten Sie ON, um den Schlüssel zu öffnen und den QR-Code auf der Rückseite des Schlüssels in den Scanrahmen zu stecken',
    deviceNo: 'Zugehörige Gerätenummer',
    deviceNumber: 'Gerätenummer',
    deviceTitle: 'Gerätecodeprüfung',
    digitalKey: 'digitaler Schlüssel',
    digitalKeyDesc: 'Es ist nicht erforderlich, einen physischen Schlüssel bei sich zu tragen, unterstützt das Entriegeln des Fahrzeugs nach der Verbindung über APP Bluetooth (von einigen Modellen unterstützt)',
    directRelease: 'Direkte Veröffentlichung',
    disagree: 'Nicht zustimmen',
    displayNumberDescription: 'Die tatsächliche Anzahl der erfolgreichen Anzeigen auf dem Geräteterminal nach Ankunft der Benachrichtigungsmeldung (die Anzeigen nach 5 Tagen werden nicht gezählt)',
    displayNumberVolume: 'Anzahl der Anzeigen',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Herunterladen',
    downloadFailFile: 'Fehldatei herunterladen',
    downloadSuccessful: 'Download erfolgreich',
    downloadTemplate: 'Vorlage herunterladen',
    downloading: 'Herunterladen...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'bearbeiten',
    editAccountDeletExplain: 'Hinweis zur Kontolöschung bearbeiten',
    editActivity: 'Aktivität bearbeiten',
    editAppRating: 'Bewertungsmechanismus bearbeiten',
    editBanner: 'Banner bearbeiten',
    editDataDeletExplain: 'Hinweis zur Löschung von Daten bearbeiten',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editInformation: 'Informationen bearbeiten',
    editInformationCategory: 'Informationskategorie bearbeiten',
    editInformationContent: 'Informationsinhalte bearbeiten',
    editKolUserAuthentication: 'KOL-Benutzerauthentifizierung bearbeiten',
    editModelSeries: 'Modellreihen bearbeiten',
    editPicture: 'Bild bearbeiten',
    editPushConfiguration: 'Push-Konfiguration bearbeiten',
    editRemark: 'Notizen bearbeiten',
    editServiceIntroduce: 'Einführung in die Redaktionsdienste',
    editShowroomModel: 'Showroom-Modelle bearbeiten',
    editSuccess: 'Erfolgreich bearbeitet',
    editTime: 'Bearbeitungszeit',
    editUnbindingCommitment: {},
    editUser: 'Benutzer bearbeiten',
    editVehicleModel: 'Modell bearbeiten',
    editVehicleModelCategory: 'Fahrzeugkategorie bearbeiten',
    effecting: 'Aktivierung ausstehend',
    effectiveTime: 'Datum des Inkrafttretens',
    electricVehicle: 'Elektrisches Fahrzeug',
    email: 'E-Mail',
    emailAdress: 'E-Mail Adresse',
    emailAdressTip: 'Hinweis: Diese E-Mail-Adresse wird für den Kundenkontakt per E-Mail verwendet. Bitte stellen Sie sicher, dass die E-Mail-Adresse korrekt ist',
    emailContent: 'Inhalt der E-Mail',
    emailImportTemplate: 'Importvorlage für E-Mail-Adressen',
    emailImportTemplateToDownLoad: 'E-Mail-Adressen können stapelweise importiert werden. Klicken Sie zum Herunterladen',
    emailList: 'E-Mail-Liste',
    emailManage: 'E-Mail-Management',
    emailMass: 'E-Mail-Explosion',
    emailSearch: 'E-Mail-Anfrage',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'Email',
    emailTitle: 'Thema',
    en_US: 'Englisch',
    enableStatus: 'Aktivierter Status',
    enabled: 'aktivieren',
    endTime: 'Endzeit',
    endTimeLargeStartTime: 'Die Endzeit muss nach der Startzeit liegen',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Um die Sicherheit Ihres Kontos zu gewährleisten, bitte bestätigen Sie Ihre Kontoinformationen, das Sie löschen möchten, und geben Sie Ihr Passwort oder einen Verifizierungscode ein, um Ihre Identität zu bestätigen.',
    enterCodeToSafeData: 'Um die Sicherheit Ihrer Daten zu gewährleisten, bitte bestätigen Sie Ihre Kontoinformationen und geben Sie Ihr Passwort oder einen Verifizierungscode ein, um Ihre Identität zu bestätigen.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Nach Eingabe der Abfragebedingungen können Sie die Daten anzeigen',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Die Längen- und Breitengrade sind falsch formatiert, bitte überprüfen Sie',
    errorLocation: {},
    es_ES: 'Spanisch',
    estimatedTime: 'Geschätzte Zeit',
    everySet: 'Pro Einstellung',
    examineResultMessage: 'Wir werden die Bewerbungsunterlagen so schnell wie möglich überprüfen. Bitte achten Sie rechtzeitig auf die Benachrichtigungsleiste oder das APP-Nachrichtencenter.',
    example: 'Beispiel',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Inhalt exportieren',
    exportExcel: 'Zu EXCEL exportieren',
    exportLengthExceedOfMonth: 'Die Dauer der Ausfuhr darf %s Monate nicht überschreiten',
    externalLink: 'Externer Link',
    failed: 'Fehlgeschlagen',
    failedToPreview: 'Prüfung fehlgeschlagen',
    feedBackResut: 'Feedback-Ergebnisse',
    feedBackTime: 'Feedback-Zeit',
    feedBackVechle: 'Fahrzeug',
    feedbackAppQuestion: 'Bitte beschreiben Sie detailliert den Zeitpunkt des Auftretens, die APP-Version, das Handymodell, den Betriebsweg und die Problembeschreibung, um das Problem schnell zu finden und zu beheben!',
    feedbackDetails: 'Rückmeldung Details',
    feedbackGuideDesc: 'Für weitere Informationen kontaktieren Sie uns bitte über den untenstehenden Feedback-Kanal',
    feedbackLabelFileList: 'Bitte laden Sie ein Bild',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Feedback fehlgeschlagen',
    feedbackOtherQuestion: 'Beschreiben Sie bitte, wann und wie es passiert ist und welches Problem vorliegt',
    feedbackReceived: 'Erhaltene Rückmeldung',
    feedbackRecord: 'Feedback-Protokoll',
    feedbackRulesFileListMaxSize: 'Die hochgeladene Datei ist zu groß',
    feedbackRulesFileListOverType: 'Nicht unterstütztes Format',
    feedbackSubmitTip: 'Wenn Sie Fragen oder Kommentare haben, können Sie sich auch direkt per WhatsApp (+52 18115286003) oder E-Mail (servicioalclient@cfmoto.com.mx) an das CFMOTO Mexico Customer Service Center wenden.',
    feedbackSuggest: 'Wir freuen uns über wertvolle Vorschläge und werden Ihre Ideen ernsthaft prüfen.',
    feedbackSupplement: 'Bitte fügen Sie eine Beschreibung des Problems hinzu',
    feedbackText: 'Rückmeldung',
    feedbackType: 'Feedbacktyp (Einfachauswahl)',
    feedbackVehicleQuestion: 'Beschreiben Sie bitte, wann und wie es passiert ist und welches Problem vorliegt',
    female: 'Weiblich',
    fileCountExceed: 'Die Anzahl der Dateien überschreitet die Grenze',
    fileSizeExceed: 'Die Dateigröße überschreitet das Limit',
    fileUploadingPleaceWait: 'Datei wird hochgeladen, bitte warten',
    finalOperator: {},
    firstMenu: 'Menü erster Ebene',
    forcedUpgrade: 'Erzwungenes Update',
    forgetPassword: 'Passwort vergessen',
    fourCarOfNumber: 'Anzahl der Vierradnutzer',
    fourWheel: 'Motorrad',
    fourWheelConfig: {},
    fourWheeler: 'Vierrad',
    fourWheelerMostClicks: 'Vierradmodelle mit den meisten Klicks',
    fourWheelowner: {},
    fr_FR: 'Französisch',
    frankfurt: 'Frankfurt',
    friday: 'Freitag',
    fuctionIntro: {},
    fullscreen: 'Vollbild-Modus',
    funServiceIntro: {},
    function: 'Funktion',
    functionConfiguration: {},
    functionConfigureTip: 'Die Funktion gilt nur für konfigurierte Fahrzeuge unter dem Namen des Importeurs oder Benutzers im Land/Region',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Bedienungsanleitung',
    functionSetting: {},
    functionalOverview: 'Überblick über die Funktionen',
    galleryEntrance: 'Galerieeingang',
    galleryEntranceUploadRules: 'Formatanforderungen: jpg/jpeg/png, empfohlenes Seitenverhältnis 4:3, Größe nicht mehr als 5 MB',
    gender: 'Geschlecht',
    generalAlarm: 'Gewöhnlicher Alarm',
    geofence: 'Elektronischer Zaun',
    getCarPosition: 'Rechtzeitige Ortung des Fahrzeugs',
    getCode: 'Schicken',
    goCustomPage: 'Zur benutzerdefinierten Seite',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Zum URL-Link',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Ohne auto',
    haveTwo: 'Beides.',
    havedWrite: 'Ausgefüllt',
    havedWriteAll: 'ausgefüllt wurden',
    havedWriteAllOrEmpty: 'ausgefüllt oder leer ist',
    helpAndFeedback: 'Hilfe & Feedback',
    helpCenter: 'Hilfezentrum',
    helpMessageHistoryDelete: 'Alle Suchdatensätze löschen?',
    helpful: {},
    hint: 'Hinweis',
    historyDelete: 'Alle Suchdatensätze löschen?',
    home: 'Startseite',
    homePage: 'Personal Home Page',
    hour: 'Stunde',
    hoursAgo: 'Vor %s Stunden',
    iWantEnableStoreUserQuery: 'Ich möchte den Benutzer für die Filialsuche aktivieren',
    iWantToPostStatistics: 'Ich möchte Statistiken veröffentlichen',
    identification: 'Identifizierung',
    identificationText: 'Identifizierung',
    imageSizeExceed: 'Bitte laden Sie ein Bild mit einer Breite und Höhe von %s hoch',
    imageUploadFailed: 'Bild hochladen fehlgeschlagen',
    immediateSend: 'Schick jetzt',
    imporFailedOfTableHeader: 'Import fehlgeschlagen.  Datei-Header nicht übereinstimmend',
    import: 'importieren',
    importDetails: 'Fragendetails',
    importExcel: 'EXCEL importieren',
    importFail: 'Import fehlgeschlagen',
    importStatus: 'Status des Imports',
    importSuccessful: 'Import erfolgreich',
    importTemplate: 'Vorlagen importieren',
    importer: 'Importeur',
    importerAccountOperationRecord: 'Kontobetrieb und Login-Datensatz des Importeurs',
    importerAvatar: 'Avatar des Importeurs',
    importerDisplayName: 'Anzeigename des Importeurs',
    importerEnquiry: 'Importeuranfrage',
    importing: 'Wird importiert...',
    inProcess: 'Gegenmaßnahmen',
    inProgress: 'in Bearbeitung',
    individualCenter: 'Einzelne Zentrale',
    informationCategory: 'Informationskategorie',
    informationCategoryList: 'Liste der Informationskategorien',
    informationCategoryQuery: 'Abfrage der Informationskategorie',
    informationContent: 'Informationsgehalt',
    informationContentList: 'Liste der Informationsinhalte',
    informationCotnentQuery: 'Abfrage des Informationsinhalts',
    informationCover: 'Informationsdeckung',
    informationDetails: 'Informationen Details',
    informationImage: 'Titelbild',
    informationManagement: 'Informationsmanagement',
    informationTitle: 'Informationstitel',
    informer: 'Informant',
    informerId: 'Informant-ID',
    initialPassword: 'Ursprüngliches Passwort',
    inputAgreementContent: 'Bitte geben Sie den Inhalt der Vereinbarung ein',
    inputErrorEmoji: 'Bitte keine Emoticons eingeben',
    installDeviceYouCan: 'Durch die Installation dieses Geräts können Sie',
    installVehicleModelAdd: 'Hinzufügen Beschreibung des nachgerüsteten Fahrzeugmodells',
    installVehicleModelDescription: 'Beschreibung des nachgerüsteten Modells',
    installVehicleModelEdit: 'Bearbeiten Beschreibung des nachgerüsteten Fahrzeugmodells',
    instrumentLastedVersion: 'TFT-Display, kein Upgrade nötig',
    instrumentupgrade: 'Upgrade des TFT-Displays',
    intelligentInternetServiceIntroduction: 'Einführung in den Dienst',
    introText: {},
    introduction: 'Einführung',
    invalidVercode: 'Ungültiger Bestätigungscode',
    iovNotice1: 'Die oben genannten Funktionen basieren auf FInternet of Vehicles-Ausrüstung (T-Box), bitte konsultieren Sie den lokalen Händler zum Kauf und zur Installation',
    iovNotice2: 'Die oben genannten Funktionen sind je nach Konfiguration der einzelnen Modelle und der Region, in der sie sich befinden, unterschiedlich. Bitte konsultieren Sie den örtlichen Händler für Einzelheiten.',
    iovNotice3: 'Bitte speichern und notieren Sie vorab die Gerätenummer, die zum Binden des Gerätes benötigt wird. Nach Abschluss der Bindung und Installation können Sie weitere Funktionen nutzen',
    isHelpful: 'Hilft es?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'Italienisch',
    iterativeVehicleFunctions: 'Die Hauptteile des Fahrzeugs können aus der Ferne online aktualisiert werden, um die Fahrzeugfunktionen kontinuierlich zu verbessern',
    jumpSettings: 'Sprungeinstellungen',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Gerade jetzt',
    kolUserList: 'Liste der KOL-Benutzer',
    kolUserManagement: 'KOL-Benutzerverwaltung',
    kolUserQuery: 'KOL-Benutzerabfrage',
    language: 'Sprache',
    language1: 'Zugehörige Sprache',
    languages: 'Sprache',
    lastLoginTime: 'Letzte Anmelde-Zeit',
    lastModifiedBy: 'Zuletzt geändert von',
    lastUpdateTime: 'Letzte Aktualisierungszeit',
    latitude: 'Längengrad',
    launchActivity: 'Aktivität veröffentlichen',
    likeNumber: 'Anzahl der Likes',
    linkAddress: {},
    linkUrlDescription: {},
    listDisplayImages: 'Listenanzeige',
    listOfImporters: 'Liste der Importeure',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Listings zeigen Shop-Cover-Art',
    loadSuccess: 'Laden abgeschlossen',
    loading: 'Laden',
    locationFail: {},
    log: 'Protokoll',
    login: 'Einloggen',
    loginCountry: 'Anmeldeland/-region',
    logout: 'Anmeldestatus beenden',
    longitude: 'Längengrade',
    loosing: 'Erfrischende Daten...',
    lowCompatibleVersion: 'Minimale kompatible Version',
    mail: 'E-Mail',
    male: 'Männlich',
    manualReviewStatus: 'Status manuelle Prüfung',
    mapManage: {},
    marketDataOfdealerStores: 'Marktdaten der Händlergeschäfte',
    masteringCyclingData: 'Master-Fahrdaten',
    maximum: 'Max.',
    maximumBannerCountTip: 'Es können maximal %s Banner gleichzeitig online sein. Bitte mindestens eines entfernen.',
    maximumValue: 'Maximum',
    menuFunctionName: 'Menüfunktions-Verwltg.',
    menuIcon: 'Menü-Symbol',
    messagePush: 'Push-Nachrichten',
    messagePushDeleteAsk: 'Wollen Sie diese Push-Nachricht wirklich löschen?',
    messagePushDownloadTemplate:
      'Bitte laden Sie zuerst die Vorlage herunter und laden Sie die Datei nach dem Ausfüllen der Vorlagendatei hoch.  Die Dateigröße ist auf 2M begrenzt.  Wenn die Übermittlung fehlschlägt, kürzen Sie bitte den Inhalt entsprechend',
    messageWithdrawAsk: 'Wollen Sie dieses Push zurückziehen?',
    middle: 'Mitte',
    min: 'Min',
    minAgo: 'Vor %s Minuten',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Modelldetails',
    modifyFail: 'Änderung fehlgeschlagen',
    modifyPassword: 'Passwort ändern',
    modifySuccess: 'Ändern erfolgreich',
    monday: 'Montag',
    more4pic1video: 'Maximal 4 Bilder / 1 Video',
    morning: 'Morgen',
    motorcycle: 'Zweiräder',
    moveDown: 'Abwärts bewegen',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Bewegen nach',
    moveToBottom: 'Nach unten bewegen',
    moveToTop: 'Nach oben bewegen',
    moveToTopStatus: 'Nach oben',
    moveTop: 'Nach oben',
    moveUp: 'Aufwärts bewegen',
    multimedia: 'Multimedia',
    mustInteger: {},
    mute1Day: 'Verbot für 1 Tag',
    mute2Days: 'Verbot für 2 Tage',
    mute30Days: 'Verbot für 30 Tage',
    mute3Days: 'Verbot für 3 Tage',
    mute7Days: 'Verbot für 7 Tage',
    muting: 'Verbot',
    nameOfImporter: 'Name des Importeurs',
    navigation: 'Kartennavigation',
    nearLoginTime: 'Letzte Anmeldezeit',
    needPopup: 'Benötige ein Popup-Fenster',
    negativeNum: 'Schlechte Bewertung',
    networkException: 'Netzwerk-Ausnahme',
    newAddFail: 'Hinzufügen fehlgeschlagen',
    newAddSuccess: 'erfolgreich hinzugefügt',
    newBanner: 'Neues Banner',
    newCancellationAgreement: 'Neuer Stornierungsvertrag',
    newFunctionIntro: {},
    newMenuFunction: 'Neue Menüfunktion',
    newModelSeries: 'Neue Modellreihe',
    newPassword: 'Neues Passwort',
    newPasswordNotEqual: 'Das zweimal eingegebene neue Passwort ist inkonsistent, bitte erneut eingeben',
    newQuestionType: {},
    newStoreNumber: 'Anzahl neuer Geschäfte',
    newTopic: 'Neues Thema',
    newUnbindingCommitment: {},
    nextStep: 'Weiter',
    nickName: 'Nickname',
    no: 'Nein',
    noContent: 'Kein verwandter Inhalt',
    noContent2: 'Schlagen Sie vor, Schlüsselwörter zu ändern oder',
    noData: 'Keine Daten',
    noFeedbackRecord: 'Zurzeit gibt es keine Rückmeldungen.',
    noJump: 'Kein Sprung',
    noLog: 'Kein Protokoll',
    noNeedPopup: 'Keine Popups erforderlich',
    noOkToFeedback: 'Ungelöst, ich möchte Feedback geben',
    noOwnerScore: 'Bewertungen von Nicht-Eigentümern',
    noPass: 'Nicht bestanden',
    noSendPeople: 'Kein Sender',
    noSupportMapDown: {},
    noThisPermission: 'Keine Genehmigung für diesen Vorgang',
    noUserSelected: 'Kein Benutzer ausgewählt, kann nicht gesendet werden',
    nofiledSeviceContent: {},
    nonOwner: 'Nicht-Eigentümer',
    nonVehicleOwnerCharged: {},
    none: 'Nichts',
    normal: 'Normal',
    notAllowImageAndVideo: 'Video kann bei der Auswahl von Bildern nicht ausgewählt werden',
    notAllowed: 'Nicht erlaubt',
    notBeLessOrEqual: 'Darf nicht kleiner oder gleich sein als',
    notDeleted: 'Nicht storniert',
    notDistributedYet: 'Noch nicht verteilt',
    notEnabled: 'Nicht aktiviert',
    notHelpful: {},
    notLessThan: 'Darf nicht kleiner sein als',
    notRecommended: 'Nicht empfohlen',
    notReleasedYet: 'Noch nicht veröffentlicht',
    notStarted: {},
    notTop: 'Nicht nach oben',
    notice: 'Notiz',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. In order to continuously improve your service experience, we are committed to enhancing service quality and implementing innovative improvements. In this context, we have made business adjustments and hereby notify you that as of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In order to ensure that your service experience is not affected, we have launched a brand-new CFMOTO RIDESYNC App. We hope you can continue to enjoy our new services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Versionsnummern können nicht alle 0 sein',
    offline: 'Offline',
    offlineAlready: 'Off-line',
    offlineTime: 'Offline-Zeit',
    offlineTimeMustBeGreaterThan: 'Offline-Zeit muss größer sein als',
    ok: 'OK',
    oldPassword: 'Altes Passwort',
    onLineAlready: {},
    oneMonths: 'Ein Monat',
    oneYear: 'Ein Jahr',
    online: 'online',
    onlyFourWheel: 'Nur vierrädrige Räder',
    onlyTwoWheel: 'Nur zwei Räder',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Betriebsprotokoll',
    operationTime: 'Betriebszeit',
    operations: 'Betriebe',
    operator: 'Betreiber',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Optionales Update',
    orderList: {},
    orderMange: {},
    orderNum: {},
    otaUpgradeVehicle: 'OTA-Upgrade-Fahrzeug',
    otaUpgradeVehicleDesc: 'Die Hauptkomponenten des Fahrzeugs können aus der Ferne aktualisiert werden, um die Fahrzeugleistung kontinuierlich zu verbessern.',
    other: 'Sonstiges',
    over: 'über',
    owner: 'Mit auto',
    ownerIdHomepageImage: 'Hauptseite des Personalausweises, Führerscheins oder Reisepasses mit Angaben zur persönlichen Identifizierung',
    parameterConfiguration: 'Parameterkonfiguration',
    partialImportFailed: 'Teilimport fehlgeschlagen',
    pass: 'Bestanden',
    passValidateDeleteAccount: 'Erfolgreiche Identitätsprüfung!  Klicken Sie unten auf die Schaltfläche Antrag-Einreichen, um die Löschung des Kontos zu beantragen',
    password: 'Passwort',
    passwordRuleText: '8–20 Zeichen, muss englische Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten',
    passwordRules: 'Passwortregeln ',
    paySetting: {},
    payStrategy: {},
    peleaseEnterProvince: 'Bitte Provinz/Staat eingeben',
    pendSend: 'Ausstehend',
    pending: 'Ausstehend.',
    permanentMuting: 'Dauerhaftes Verbot',
    phoneModel: 'Modell',
    phoneNum: 'Telefonnummer',
    phoneNumber: 'Telefon-Nummer',
    phoneOrEmail: 'Telefonnummer/E-Mail',
    phoneOrEmailImportTemplate: 'Vorlage zum Importieren von Mobiltelefonnummern/E-Mail-Adressen',
    phoneOrEmailNotRegistered: 'Diese Mobiltelefonnummer oder E-Mail-Adresse ist nicht registriert',
    phoneOrEmailOrUserId: 'Mobiltelefonnummer/E-Mail-Adresse/Benutzer-ID',
    picture: 'Bild',
    pl_PL: 'Polieren',
    pleaseAddImage: 'Bitte fügen Sie Bilddateien hinzu',
    pleaseAddVideoFile: 'Bitte fügen Sie Videodateien hinzu',
    pleaseEnter: 'Bitte eingeben',
    pleaseEnterAccountInfo: 'Bitte geben Sie Kontoinformationen ein',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Bitte geben Sie eine Stadt ein',
    pleaseEnterEmail: 'Bitte geben Sie Ihre E-Mail Adresse ein',
    pleaseEnterEmailAdress: 'Bitte geben Sie die E-Mail Adresse ein',
    pleaseEnterIntro: 'Bitte geben Sie eine Einleitung ein',
    pleaseEnterLatAndLong: 'Bitte geben Sie den Breiten- und Längengrad ein',
    pleaseEnterNewPassword: 'Neues Passwort eingeben',
    pleaseEnterPassword: 'Bitte geben Sie ein Passwort ein',
    pleaseEnterPhone: 'Bitte geben Sie Ihre Telefonnummer ein',
    pleaseEnterQuestionDescription: 'Bitte geben Sie eine Beschreibung Ihres Problems ein',
    pleaseEnterRealname: 'Bitte geben Sie Ihren richtigen Namen ein',
    pleaseEnterRemark: 'Bitte geben Sie eine Bemerkung ein',
    pleaseEnterServePhone: 'Bitte geben Sie die Dienstnummer ein',
    pleaseEnterStoreAddressDetail: 'Bitte geben Sie die detaillierte Adresse ein',
    pleaseEnterStoreIntroduce: 'Bitte geben Sie die Einführung ins Geschäft ein',
    pleaseEnterStoreName: 'Bitte geben Sie den Geschäftsnamen ein',
    pleaseEnterStoreRemarkName: 'Bitte geben Sie den Name der Geschäftsanmerkung ein',
    pleaseEnterTitle: 'Bitte geben Sie einen Titel ein',
    pleaseEnterUsername: 'Geben Sie einen Benutzernamen ein',
    pleaseEnterVercode: 'Geben Sie Vercode ein',
    pleaseEnterVersion: 'Bitte geben Sie die Versionsnummer ein',
    pleaseEnterVersionIntroduction: 'Bitte geben Sie eine Einführung in die Version ein',
    pleaseEnterVideoDetail: 'Bitte geben Sie die Videodetails ein',
    pleaseEnterVin: 'Bitte geben Sie die VIN ein',
    pleaseInputWord: 'Bitte Schlüsselwort eingeben',
    pleaseLoginFirst: 'Bitte erst anmelden',
    pleaseRepeatNewPassword: 'Bitte wiederholen Sie das neue Passwort',
    pleaseSelect: 'Bitte auswählen',
    pleaseSelectBusinessHours: 'Bitte wählen Sie Geschäftszeiten',
    pleaseSelectCity: 'Bitte wählen Sie eine Stadt aus',
    pleaseSelectCountry: 'Bitte wählen Sie ein Land aus',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Bitte den passenden Multimedia-Inhalt wählen',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Bitte wählen Sie ein Szenario, in dem das Problem auftritt',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Bitte wählen Sie eine Provinz/Staat aus',
    pleaseSelectQueType: 'Bitte wählen Sie die Art der Frage',
    pleaseSelectReportReason: 'Bitte wählen Sie den Grund für die Meldung aus',
    pleaseSelectStatus: 'Bitte Status auswählen',
    pleaseSelectStoreType: 'Bitte wählen Sie den Shop-Typ',
    pleaseSelectTimedSendTime: 'Bitte Sendezeitpunkt auswählen',
    pleaseSelectUserTheList: 'Bitte einen Benutzer aus der Liste wählen',
    pleaseSelectVehicle: 'Bitte wählen Sie ein Fahrzeug aus',
    pleaseSelectVehicleConfig: {},
    pleaseSelectupgradeType: 'Bitte wählen Sie die Update-Methode aus',
    pleaseSureType2: 'Bitte stellen Sie sicher, dass alles in',
    pleaseUpload: 'Bitte hochladen',
    pleaseUploadPicVideo: 'Bitte laden Sie Bilder/Videos hoch',
    popUpFrequencyType: 'Popup-Fensterformular',
    popUpFrequencyValue: 'Popup-Häufigkeit',
    popUpFrequencyValueValid: 'Bitte wählen Sie die Häufigkeitstage aus',
    popUpReminder: 'Ob eine Erinnerung angezeigt werden soll',
    popupArea: 'Pop-up-Benutzerbereich',
    popupCreate: {},
    popupDayOne: 'Einmal pro festgelegter Anzahl von Tagen',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Gute Rückmeldungen',
    postComment: 'Beitrag-Kommentar',
    postContent: 'Beitragsinhalt',
    postId: 'Beitrags-ID',
    postList: 'Beitragsliste',
    postManagement: 'Management des Beitrags',
    postSearch: 'Beitragssuche',
    posts: 'Beiträge',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Inhaltsdetails der Datenschutzrichtlinie',
    privacyPolicy: 'Datenschutzrichtlinie',
    privacyPopupAgree: 'Holen Sie über ein Popup-Fenster erneut die Einwilligung des Nutzers zur Datenschutzerklärung ein',
    privacyVersion: 'Version der Datenschutzrichtlinie',
    privacyVersionList: 'Versionsliste der Datenschutzrichtlinie',
    problemaDes: 'Beschreibung des Problems',
    processMethod: 'Bearbeitungsmethoden',
    processReason: 'Bearbeitungsgrund',
    processReasonDetails: 'Details zum Bearbeitungsgrund',
    processRecord: 'Bearbeitungsprotokoll',
    processReport: 'Berichte bearbeiten',
    processSolution: 'Lösung für Bearbeitung',
    processUser: 'Benutzer verarbeiten',
    processed: 'Verarbeitet',
    productDetails: {},
    productTime: 'Produktionszeit',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'Portugiesisch',
    publishInformation: 'Informationen veröffentlichen',
    publishPosts: 'Beiträge veröffentlichen',
    pullBefore: 'Zum Auffrischen nach unten ziehen.',
    pulling: 'Jetzt aktualisieren',
    purchaseAndInstall: 'kaufen und installieren',
    pushConfiguration: 'Push-Konfiguration',
    pushContent: 'Inhalte pushen',
    pushList: 'Push-Liste',
    pushMode: 'Push-Modus',
    pushNow: 'Jetzt pushen',
    pushQuery: 'Push-Abfrage',
    pushRecord: 'Push-Rekord',
    pushScope: 'Push-Umfang',
    pushTime: 'Push-Zeit',
    pushTimeDifferenceAsk: 'Die von Ihnen gewählte Sendezeit kann dazu führen, dass einige Benutzer diesen Push aufgrund von Zeitunterschieden nicht empfangen können. Möchten Sie wirklich speichern?',
    pushTitle: 'Push-Titel',
    pushed: 'Gedrängt',
    pushing: 'Pushen',
    query: 'Suchen',
    question: {},
    questionInquiry: {},
    questionType: 'Frage Typ',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Schnell veröffentlichen',
    ranking: 'Rangliste',
    ratingWarn1:
      'Für Benutzer von Fahrzeugbesitzern wurde die dem Land/der Region entsprechende Smart-Service-Steuerung im Verwaltungshintergrund nicht aktiviert oder der Smart-Service-Dienst ist nach der Aktivierung nicht abgelaufen. Das Fahrzeug ist online und verfügt über',
    ratingWarn2: 'oder mehr vollständige Fahrtaufzeichnungen (der Beginn und das Ende jeder Fahrt werden gemeldet). Ein Popup wird angezeigt, wenn der Benutzer My Cycling verlässt und zur Startseite zurückkehrt.',
    reUpgrade: 'Erneut upgraden',
    readAgree: 'Lesen und akzeptieren Sie die',
    readAndAgree: 'Bitte lesen und zustimmen',
    readAndAgreeTo: 'Ich habe die gelesen und bin damit einverstanden',
    readDeleteStep: 'informieren Sie sich über die Arten von Daten, die wir löschen oder aufbewahren, sowie über etwaige zusätzliche Aufbewahrungsfristen',
    realname: 'Echter Name',
    reasonForReport: 'Grund',
    receiveCarReminderMessage: 'Empfangen von Fahrzeugmeldungswarnungen',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Empfänger',
    recipientsNum: 'Empfängerbereich',
    recommended: 'Empfohlen',
    recommendedStatus: 'Empfohlener Status',
    redirectUrl: {},
    refreshInterval: 'Intervall aktualisieren',
    refreshSend: 'erneut senden',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Abgelehnt',
    registerDate: 'Anmeldezeit',
    rejected: 'Abgelehnt',
    releaseContent: 'Inhalt veröffentlichen',
    releaseMute: 'Verbot aufheben',
    releaseTime: 'Freigabezeit:',
    released: 'Veröffentlicht',
    releasedBy: 'Veröffentlicht von',
    remark: 'Notizen',
    rememberPassword: 'Passwort notieren',
    reminder: 'Erinnerung',
    remove: 'Entfernen',
    removeOnlinUpgrade: 'Ferngesteuertes Online-Upgrade-Fahrzeug',
    repeatNewPassword: 'Neues Passwort wiederholen',
    replaceTBOX: 'TBOX ersetzen',
    replied: 'antwortete',
    reply: 'Antworten',
    report: 'Melden',
    reportList: 'Meldeliste',
    reportManagement: 'Management der Meldung',
    reportReason: 'Grund für Meldung',
    reportReasonDetails: 'Details zum Grund für Meldung',
    reportReasonPlaceholder: 'Schreiben Sie, was Sie berichten wollen, 0-1500 Wörter',
    reportSearch: 'Abfrage der Meldung',
    reportSuccessful: 'Erfolgreiche Meldung, wir werden uns so schnell wie möglich darum kümmern',
    reportTime: 'Meldungszeit',
    reportType: 'Art des Berichts',
    reportedContent: 'Gemeldeter Inhalt',
    reportedUser: 'Gemeldeter Benutzer',
    reportedUserId: 'ID des gemeldeten Benutzers',
    requestTimedOut: 'Anfrage abgelaufen',
    reset: 'Zurücksetzen',
    return: 'Zurück',
    review: 'Überprüfung',
    reviewApproved: 'Prüfung bestanden',
    richText: {},
    ro_RO: 'rumänisch',
    roleDescription: 'Rollenbeschreibung',
    roleName: 'Rollenbezeichnung',
    rolePermission: 'Rollen-Genehmigung',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Russisch',
    safeRemind: 'Um die Sicherheit Ihres Kontos zu schützen, übermitteln Sie hier bitte keine sensiblen persönlichen Daten, wie z. B. Kontopasswörter usw.',
    satelliteMap: 'Karte des Satelliten',
    saturday: 'Samstag',
    save: 'Speichern',
    saveAndPreview: 'Speichern und Vorschau anzeigen',
    saveFail: 'Speichern fehlgeschlagen',
    savePicture: 'Bild speichern',
    saveSettings: 'Einstellungen speichern',
    saveSuccess: 'Erfolgreich gespeichert',
    saveVideo: 'Video speichern',
    scanQrcodePreview: 'Scannen Sie den QR-Code unten mit Ihrem Mobiltelefon, um eine Vorschau anzuzeigen',
    screenNavigationGuidance: 'Setup-Anweisungen',
    sdkStatement: 'SDK-Anweisung',
    search: 'Suche',
    searchRecords: 'Verlaufssuche',
    secondaryMenu: 'sekundäres Menü',
    securityMessage: 'Die oben genannten Informationen werden nur zur Identitätsprüfung verwendet, CFMOTO schützt Ihre Daten',
    select: 'Wählen',
    selectAll: 'Alles auswählen',
    selectAuthentication: 'Authentifizierung auswählen',
    selectChannelType: 'Bitte wählen Sie einen Feedbackkanal aus',
    selectCountry: 'Land auswählen',
    selectData: 'Bitte wählen Sie die Daten aus, die Sie löschen möchten, und klicken Sie unten auf die Schaltfläche Einreichen, um Ihren Antrag auf Datenlöschung zu übermitteln.',
    selectDate: 'Datum auswählen',
    selectEnableStatus: {},
    selectFeedBackState: 'Wählen Sie den Feedback-Verarbeitungsstatus aus',
    selectFeedbackType: 'Bitte wählen Sie einen Feedback-Typ aus',
    selectJumpTarget: {},
    selectLanguage: 'Bitte Sprache auswählen',
    selectOneCarType: 'Wählen Sie mindestens ein Modell aus',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Bitte wählen Sie einen Grund für die Ablehnung aus',
    selectTheLanguage: 'Sprache',
    selectTime: 'Uhrzeit auswählen',
    selectUser: 'Benutzer auswählen',
    selectVehicle: 'Fahrzeug auswählen',
    selectionOfImporter: 'Auswahl des Importeurs',
    sendNumberDescription: 'Unter den effektiven Zielgeräten erstellt der Aurora-Server tatsächlich erfolgreich die Anzahl der Geräte, die Aufgaben senden',
    sendNumberVolume: 'Anzahl der Sendungen',
    sendType: 'Sendemodus',
    sendUserNum: 'Anzahl der Sendungen',
    sending: 'Beim Senden',
    serial: 'Nein.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Serie Einführung',
    seriesName: {},
    seriesShowcase: 'Serie Schaufenster',
    seriesUplodImgRule: {},
    seriousAlarm: 'Serious alarm',
    serviceIntroduction: 'Einführung in den Dienst',
    serviceText: 'Dienst',
    settingSuccess: 'Erfolgreich eingestellt',
    shareNumber: 'Anzahl der Teilungen',
    sheet: 'Blatt Papier',
    show: 'Ansicht',
    showPicturesOfVideos: 'Bilder/Videos anzeigen',
    showroomModel: 'Showroom Modelle',
    showroomModelList: 'Liste der Showroom-Modelle',
    showroomModelQuery: 'Anfrage für Showroom-Modelle',
    showroomUploadRules: 'Das erforderliche Bildformat ist JPG/JPEG/PNG, das Bildverhältnis beträgt 9:19,5, die Größe darf 5 MB nicht überschreiten und die Videogröße darf 50 MB nicht überschreiten',
    signOut: 'Automatische Beendigung',
    singapore: 'Singapur',
    sixMonths: 'Sechs Monate',
    slideToRight: 'wische nach rechts',
    smartServices: 'Intelligente Dienste',
    someUser: 'Einige Benutzer',
    sort: 'Art',
    source: 'Quelle',
    sr_YU: 'serbisch',
    startChecking: 'Prüfung starten',
    startTime: 'Startzeit',
    statisticalTime: 'Statistische Zeit',
    status: 'Status',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Hinweis: Diese Geschäftsadresse ist die einzige Grundlage dafür, dass Nutzer Sie finden können. Bitte füllen Sie die Felder sorgfältig aus, um sicherzustellen, dass die Adresse korrekt ist.',
    storeAddressDetail: 'Geschäftsadresse',
    storeAddressDetailTip: 'Beispiel: detaillierte Adresse:  NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Breitengrad und Längengrad',
    storeAddressPositionTip:
      'Längengrad: Der ganzzahlige Teil des Längengrads ist eine ganze Zahl von -180 bis 180, und der Dezimalteil ist eine Dezimalzahl mit höchstens 15 Stellen.\nBreitengrad: Der ganzzahlige Teil des Breitengrads ist eine ganze Zahl von -90 bis 90, und der Dezimalteil besteht aus höchstens 15 Dezimalstellen.',
    storeBusinessType: 'Typ des Geschäfts',
    storeImage: 'Bild des Geschäfts',
    storeImportTemplateText:
      'Bitte laden Sie die Vorlage herunter, füllen Sie die Informationen zum Händlergeschäft in der Vorlagendatei aus und laden Sie dann die Datei hoch. Die Dateigröße ist auf 1 MB begrenzt. Wenn das Hochladen fehlschlägt, reduzieren Sie bitte den Inhalt oder laden Sie ihn stapelweise hoch',
    storeIntroduce: 'Einführung ins Geschäft',
    storeList: 'Liste der Geschäfte',
    storeMange: 'Shop Management',
    storeName: 'Geschäftsname',
    storeNameTip: 'Hinweis: Bitte wählen Sie eine vom System unterstützte Sprache aus, um den Geschäftsnamen einzugeben',
    storeQueryUserStatistics: 'Benutzerstatistik für die Geschäftssuche',
    storeRemarkName: 'Name der Geschäftsanmerkung',
    storeRemarkNameTip: 'Hinweis: Wenn die vom System unterstützte Sprache nicht Ihren Anforderungen entspricht, können Sie hier den Name der Geschäftsanmerkung in der gewünschten Sprache eingeben.',
    storeSearch: 'Abfrage von Geschäften',
    storeServicePhone: 'Service-Telefonnummer',
    storeServicePhoneTip: 'Hinweis: Diese Nummer wird für den telefonischen Kundenkontakt verwendet. Bitte stellen Sie sicher, dass die Telefonnummer korrekt ist.',
    storeServiceTime: 'Öffnungszeit',
    storeStatistics: 'Filialstatistik',
    storeUploadImageRequire:
      'Bildformat Anforderungen für jpg/jpeg/png, ist es empfehlenswert, dass die Größe eines einzelnen Bildes nicht mehr als 5MB, ein einziger Import von bis zu 9, kann mehr als einmal importiert werden, die Gesamtzahl von nicht mehr als 9',
    storefront: 'Geschäft',
    submissionFailed: 'Senden fehlgeschlagen, bitte versuchen Sie es erneut.',
    submit: 'Absenden',
    submitAccountDeleteApply: 'Senden Sie den Antrag auf Kontolöschung ab',
    submitDataDeleteApply: 'Senden Sie den Antrag auf Datenlöschung ab',
    submitFeedback: 'Feedback abgeben',
    submitted: 'Eingereicht',
    successful: 'Erfolgreich',
    sunday: 'Sonntag',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Zustimmen oder nicht?',
    sureBackApply: 'Bestätigen Sie den Widerruf des Antrags auf Kontolöschung',
    sureDelete: 'Einmal gelöscht, kann es nicht wiederhergestellt werden. Sind Sie sicher, dass Sie es löschen möchten',
    sureDeleteData: 'Wollen Sie die ausgewählten Daten löschen?  Nach der Bestätigung werden die Daten sofort gelöscht und können nicht wiederhergestellt werden',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Bestätigen Sie die Löschung dieser Shop-Informationen? Nach der Löschung können die Informationen nicht wiederhergestellt werden',
    sureReject: 'Wollen Sie ablehnen?',
    sureSuspend: 'Der Versand wird nach der Beendigung gestoppt. Sind Sie sicher, dass Sie kündigen möchten',
    suspend: 'Beenden Sie',
    sv_SE: 'Schwedisch',
    switchLanguage: 'Umschalten der Sprache',
    system: 'System',
    systemBusy: 'Das System ist beschäftigt, bitte versuchen Sie es später erneut',
    systemVersion: 'Systemversion',
    tboxIntro: 'Die T-Box ist das Schlüsselgerät zur Realisierung der intelligenten Internet of Vehicles-Ausrüstung von Fahrzeugen',
    teamConfigTip: {},
    threeMonths: 'Drei Monate',
    thursday: 'Donnerstag',
    time: 'Zeit',
    timeSend: 'Zeitgesteuertes Senden',
    timedOffline: 'Zeitgesteuert offline',
    timedPush: 'Zeitgesteuertes Pushen',
    timedRelease: 'Zeitgesteuerte Veröffentlichung',
    timedSendTime: 'Zeit senden',
    tips: 'Tipps',
    title: 'Titel',
    to: 'Zu',
    toBeReleased: 'Zu veröffentlichend',
    topMenu: 'Menü auf höchster Ebene',
    topicContent: 'Inhalt des Themas',
    topicList: 'Liste der Themen',
    topicManagement: 'Management des Themas',
    topicSearch: 'Themensuche',
    topicTitle: 'Titel des Themas',
    totalAndlLayoutOfStores: 'Gesamtzahl und Layout der Geschäfte',
    totalClicks: {},
    totalNumber: 'Gesamtzeiten',
    tr_TR: 'Türkisch',
    triggerNum: 'Anzahl der Trigger',
    tuesday: 'Dienstag',
    turnOn: 'öffnen',
    twoCarAndFourCarOfNumber: 'Anzahl der Zwei- und Vierradnutzer',
    twoCarOfNumber: 'Anzahl der Zweiradnutzer',
    twoWheelConfig: {},
    twoWheeler: 'Zweiräder',
    twoWheelerAndFourWheeler: 'Zwei- und vierrad',
    twoWheelerMostClicks: 'Zweiradmodelle mit den meisten Klicks',
    twoWheelowner: {},
    typeMessage: 'Feedback-Art',
    types: 'Typ',
    unbind: 'Getrennt',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Ihr voller Name',
    unbound: 'ungebunden',
    understandRealtimeConditions: 'Erhalten Sie Fahrzeugvibrationen und elektronische Erinnerungsmeldungen zum Ein- und Ausfahren von Fahrzeugen und verstehen Sie den Fahrzeugstatus in Echtzeit',
    uninstallTboxDesc: 'Bei Fahrzeugen, die nicht über eine T-Box verfügen, können Sie nach der Bindung grundlegende Fahrzeuginformationen wie Rahmennummer, Motornummer und elektronisches Handbuch anzeigen.',
    unitCurrencyPer: {},
    unitMonth: 'Monat',
    unlimited: 'Unbegrenzt',
    unpaid: {},
    unprocessed: 'Nicht verarbeitet',
    unresolved: 'Können Sie das Problem immer noch nicht lösen? Klicken',
    unspecified: 'Vertraulichkeit',
    upToTopics: 'Bis zu %s Themen können hinzugefügt werden',
    updateAuthenticationTime: 'Authentifizierungszeit aktualisieren',
    updateBy: 'Updater',
    updateSuccess: {},
    updateTime: 'Aktualisierungszeit',
    updating: 'Aktualisierung',
    upgradeAgainDescription: 'Die Upgrade-Aufgabe wurde erneut verschoben. Bitte folgen Sie der „Anleitung“ oben auf der aktuellen Seite, um das TFT-Display-Netzwerk für das Upgrade anzuschließen.',
    upgradeAssistant: 'Hilfe',
    upgradeDescription: 'Wenn eine neue Version gefunden wird, folgen Sie bitte der „Anleitung“ oben auf der aktuellen Seite, um das TFT-Display-Netzwerk für das Upgrade anzuschließen.',
    upgradeSuccessful: 'Upgrade erfolgreich',
    upgradeType: 'Update-Methode',
    upload: 'Hochladen',
    uploadDisplayPicture: {},
    uploadFail: 'Hochladen fehlgeschlagen',
    uploadFailed: 'Der Upload ist fehlgeschlagen. Bitte versuchen Sie es mit einem anderen Netzwerk',
    uploadFailedOfTry: 'Upload fehlgeschlagen, bitte versuchen Sie es erneut',
    uploadFileMore1M: 'Die Größe der Upload-Datei überschreitet nicht 1 M',
    uploadFiles: 'Datei hochladen',
    uploadImageRules1To1: 'Das Bildformat muss jpg/jpeg/png sein, mit einem 1:1 Bildverhältnis und einer maximalen Größe von 5MB',
    uploadLog: 'Upload-Protokoll',
    uploadPicture: 'Bild hochladen',
    uploadQuantityExceed: 'Die Anzahl der Uploads überschreitet das Limit',
    uploadSuccessful: 'Hochladen erfolgreich',
    uploadTime: 'Ladezeit',
    uploadTip556_740: {},
    uploadVideoRules: 'Es wird nur das einzelne Hochladen von Videodateien unterstützt. Es wird empfohlen, dass die Größe eines einzelnen Videos 50 MB nicht überschreitet.',
    uploadVideoRules4To3: 'Unterstützt Videoformat, empfohlenes Verhältnis von 4:3, Größe nicht mehr als 50MB',
    urlLink: 'URL-Link',
    user: 'Benutzer',
    userEmail: 'E-Mail',
    userGender: 'Geschlecht des Benutzers',
    userId: 'Benutzer-ID',
    userIdTemplate: 'Benutzer-ID-Import-Vorlage',
    userIdentity: 'Benutzer-ID',
    userLocalTime: 'Ortszeit des Benutzers',
    userLogin: 'Login',
    userMobilePhone: 'Handy',
    userModel: 'Benutzermodelle',
    userName: 'Name des Benutzers',
    userName1: {},
    userNickname: 'Spitzname des Benutzers',
    userNum: 'Benutzernummer',
    userPhone: 'Mobiltelefonnummer',
    userRealName: 'Real name',
    userReply: 'Ausstehende Benutzerantwort',
    userStatus: 'Benutzerstatus',
    userType: 'Benutzertyp',
    userUnbind: 'Benutzer trennen',
    users: 'Benutzer',
    vacationTime: 'Urlaubszeit',
    validNumberVolume: 'Anzahl der gültigen Ziele',
    validNumerDescription: 'Die von der Push-Aufgabe ausgewählte Zielgruppe und die Anzahl der Zielgeräte nach der Wirksamkeitsprüfung',
    validateEmail: 'Das Format der E-Mail-Adresse ist falsch, bitte überprüfen Sie es',
    validateImageRadio: 'Anforderungen an das Bilddateiformat: %s, Bildmaßstab: %s, nicht mehr als %s',
    validateImageSize: 'Anforderungen an das Bilddateiformat: %s, empfohlene Bildgröße: %s, nicht mehr als %s',
    validatePhone: 'Formatfehler der Telefonnummer, bitte überprüfen',
    validateVideo: 'Anforderungen an das Videodateiformat: %s, nicht mehr als %s',
    validateVin: 'Falsche Fahrzeugidentifikationsnummer (VIN), bitte überprüfen Sie.',
    vehicleAlarmDetails: 'Details zum Fahrzeugalarm',
    vehicleBindDuration: 'Dauer der Fahrzeugbindung',
    vehicleBrochure: 'Fahrzeugbroschüre',
    vehicleColor: 'Fahrzeugfarbe',
    vehicleDetails: 'Details des Fahrzeugs',
    vehicleDrivingLicense: 'Fahrzeugzulassungsbescheinigung',
    vehicleFaultDetails: 'Details zum Fahrzeugfehler',
    vehicleGallery: 'Fahrzeuggalerie',
    vehicleGalleryEntranceConfiguration:
      'Die Bilder der APP-Motorrad-Showroom-Seite und der Eingangsbilder der Fahrzeuggalerie-Funktion stammen alle aus der folgenden Konfiguration. Bitte stellen Sie sicher, dass die drei Bilder in der Konfiguration vollständig sind.',
    vehicleGalleryEntranceSettings: 'Einstellungen für den Eingang zur Fahrzeuggalerie',
    vehicleGalleryUploadRules: 'Das erforderliche Bildformat ist jpg/jpeg/png. Es wird empfohlen, dass die Größe eines einzelnen Bildes 5 MB nicht überschreitet. Es können maximal 10 Bilder gleichzeitig importiert werden. Mehrfachimporte sind zulässig.',
    vehicleIdHomepageImage: 'Fahrzeugschein-Hauptseite mit dem Namen des Besitzers und der VIN',
    vehicleModel: 'Fahrzeugmodell',
    vehicleModelAlbum: 'Modellalbum',
    vehicleModelCategorySort: 'Sortieren Sie nach Fahrzeugkategorie',
    vehicleModelDescription: 'Modellbeschreibung',
    vehicleModelList: 'Modellliste',
    vehicleModelManagement: 'Fahrzeugmodellverwaltung',
    vehicleModelName: 'Modellname',
    vehicleModelQuery: 'Abfrage des Fahrzeugmodells',
    vehicleModelSeries: 'Modellreihen',
    vehicleModelSorting: 'Modellsortierung',
    vehicleModelType: 'Modelltyp',
    vehicleName: 'Name des Fahrzeugs',
    vehicleNetworkEquipment: 'Internet of Vehicles-Ausrüstung',
    vehicleOutboundCountry: 'Ausgangsland des Fahrzeugs',
    vehicleRemark: 'Anmerkungen zum Fahrzeug',
    vehicleShareInstruction: 'Anweisungen zur Fahrzeugteilung',
    vehicleShareInstructionAdd: 'Neue Fahrzeugteilungsanweisungen',
    vehicleShareInstructionEdit: 'Anweisungen zur Fahrzeugfreigabe bearbeiten',
    vehicleType: 'Motor-Nr',
    vehicleTypeSplicing: 'Rückmeldung Modell',
    vehicleUnbindingInstructions: 'Anleitung zur Beantragung der Fahrzeugfreigabe',
    versionCode: 'Versionsnummer',
    versionIntroduction: 'Versionseinführung',
    versionManage: 'Versionsverwaltung',
    versionManageList: 'Versionsverwaltungsliste',
    versionMangeTip:
      'Hinweis: Es ist nicht gestattet, eine größere Version als die aktuell im App-Markt veröffentlichte Versionsnummer zu erstellen! Das Betriebs- und Wartungspersonal muss warten, bis die neueste Version bei Google Play oder im App Store veröffentlicht wird, und dann Versionsdatensätze erstellen, die der neuesten Versionsnummer entsprechen. Das Erstellen von Datensätzen im Voraus ist nicht gestattet.',
    versionPattern: 'Die Versionsnummer kann nur als Ganzzahl von 0 bis 999 eingegeben werden.',
    versionRequired: 'Die Versionsnummer darf nicht leer sein',
    video: 'Video',
    videoContent: 'Videoinhalte',
    videoCover: 'Videocover',
    videoDetail: 'Videodetails',
    videoDisplayImages: 'Videoanzeige',
    videoFile: 'Videodatei',
    videoGuide: 'Video-Boot-Konfiguration',
    videoImageValidate: 'Anforderungen an das Bilddateiformat: PNG, JPG, JPEG, Bildverhältnis 16:9, Größe nicht mehr als 5 MB',
    videoList: 'Videoliste',
    videoMaxSizeValidate: 'Die Videogröße darf 150 MB nicht überschreiten',
    videoSizeExceed: 'Bitte laden Sie ein Video mit einer Breite und Höhe von %s hoch',
    viewAllComment: 'Alle Kommentare ansehen',
    viewCount: 'Anzahl der Aufrufe',
    viewCurrentLocation: 'Öffnen Sie die APP, um jederzeit den aktuellen Standort des Fahrzeugs anzuzeigen',
    viewCurrentLocation2: 'Öffnen Sie die APP, um jederzeit den aktuellen Standort des Fahrzeugs anzuzeigen, was praktisch ist, um Fahrzeuge aus nächster Nähe zu finden',
    viewDetails: 'Details anzeigen',
    viewFeedBackRecords: 'Feedback-Datensätze anzeigen',
    viewLocation: 'Öffnen Sie die APP, um jederzeit den Standort des Fahrzeugs zu überprüfen',
    viewModel: {},
    viewPush: 'Ansicht drücken',
    viewSeries: {},
    viewVehicleInfomation: 'Unterstützung für die Anzeige der täglichen Fahrstrecke, Kilometerstand, Dauer, Geschwindigkeit und anderer Informationen des Fahrzeugs',
    views: 'Ansichten',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'Warten auf Prüfung',
    waitUploading: 'Hochladen, bitte warten',
    waitingManualReview: 'Warten auf manuelle Prüfung',
    waitingOnline: {},
    waitingPush: 'Warten',
    wednesday: 'Mittwoch',
    whatOTA: 'Was ist OTA?',
    whyUseNavigation: 'Wie man die Navigation benutzt',
    whyUseSetting: 'So nehmen Sie allgemeine APP-Einstellungen vor',
    withCountry: 'Land/Region (IP)',
    withInformation: 'Mit Information',
    withTBOX: {},
    withdrawn: 'Zurückgezogen',
    withoutCarOfNumber: 'Anzahl der Nutzer ohne Fahrzeug',
    withoutTBOX: {},
    writeAccountToPass: 'Geben Sie die Kontoinformationen ein und schließen Sie die Identitätsprüfung ab',
    year: {},
    yes: 'Ja',
    youHaveFeedbackMessage: 'Sie haben ** Benutzer-Feedback, das nicht effektiv weiterverfolgt wurde. Bitte bearbeiten Sie es rechtzeitig',
    youthVehicleOwner: {},
    yoyGrowth: 'Erhöht um YoY',
    zh_CN: 'Chinesisch',
  },
};
